<template>
  <div class="p-2 rounded-xl min-h-screen">
    <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-3 mb-4 shadow-sm border border-gray-100">
      <h2 class="text-sm font-bold text-gray-700 mb-1">کدهای تخفیف</h2>
      <p class="text-xs text-gray-500">
        کد تخفیف بساز، نوعش رو درصدی یا مبلغ ثابت انتخاب کن، حداقل مبلغ سفارش و سقف دفعات استفاده رو تعیین کن.
      </p>
    </div>

    <!-- فرم ساخت/ویرایش -->
    <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 mb-4 p-3">
      <h3 class="text-xs font-bold text-gray-700 mb-2">{{ editingId ? "ویرایش کد تخفیف" : "کد تخفیف جدید" }}</h3>

      <div class="grid grid-cols-1 md:grid-cols-4 gap-2 mb-2">
        <div class="flex gap-1">
          <input
              v-model="form.code"
              placeholder="کد تخفیف"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
          >
          <button
              @click="generateCode"
              class="px-2 py-1.5 bg-gray-200 text-gray-700 text-[11px] rounded-lg whitespace-nowrap"
          >تولید تصادفی</button>
        </div>

        <div class="flex items-center gap-1 bg-gray-100 rounded-lg border p-1">
          <button
              @click="form.discount_type = 'p'"
              class="flex-1 px-2 py-1 text-[11px] rounded"
              :class="form.discount_type === 'p' ? 'bg-gray-800 text-white' : 'text-gray-600'"
          >درصدی</button>
          <button
              @click="form.discount_type = 'f'"
              class="flex-1 px-2 py-1 text-[11px] rounded"
              :class="form.discount_type === 'f' ? 'bg-gray-800 text-white' : 'text-gray-600'"
          >مبلغ ثابت</button>
        </div>

        <template v-if="form.discount_type === 'p'">
          <input
              type="number"
              v-model.number="form.discount_percentage"
              placeholder="درصد تخفیف"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
          >
          <input
              type="number"
              v-model.number="form.max_discount_amount"
              placeholder="سقف مبلغ تخفیف (تومان)"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
          >
        </template>
        <template v-else>
          <input
              type="number"
              v-model.number="form.fixed_amount"
              placeholder="مبلغ ثابت تخفیف (تومان)"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full md:col-span-2"
          >
        </template>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-4 gap-2 mb-2">
        <input
            type="number"
            v-model.number="form.min_order_amount"
            placeholder="حداقل مبلغ سفارش (تومان، اختیاری)"
            class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
        >
        <input
            type="number"
            v-model.number="form.usage_limit"
            placeholder="حداکثر دفعات استفاده کل (خالی = نامحدود)"
            class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
        >
        <input
            type="number"
            v-model.number="form.per_user_usage_limit"
            placeholder="حداکثر استفاده هر کاربر (خالی = نامحدود)"
            class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
        >
        <input
            type="datetime-local"
            v-model="form.start_at"
            class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
            title="شروع اعتبار"
        >
        <input
            type="datetime-local"
            v-model="form.expire_at"
            class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
            title="پایان اعتبار"
        >
      </div>

      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <label class="flex items-center gap-1 text-xs text-gray-600 cursor-pointer">
            <input type="checkbox" v-model="form.is_active">
            فعال
          </label>
          <label class="flex items-center gap-1 text-xs text-gray-600 cursor-pointer">
            <input type="checkbox" v-model="form.first_purchase_only">
            فقط اولین خرید
          </label>
          <label class="flex items-center gap-1 text-xs text-amber-700 cursor-pointer">
            <input type="checkbox" v-model="form.is_featured_on_product_page">
            نمایش در صفحه محصول (فقط یک کد)
          </label>
        </div>
      </div>

      <div v-if="form.is_featured_on_product_page" class="flex items-center gap-3 mt-2 pt-2 border-t">
        <span class="text-xs text-gray-500">متن نمایش در صفحه محصول:</span>
        <label class="flex items-center gap-1 text-xs text-gray-600 cursor-pointer">
          <input type="radio" value="amount" v-model="form.product_page_display_mode">
          مبلغ/درصد تخفیف
        </label>
        <label class="flex items-center gap-1 text-xs text-gray-600 cursor-pointer">
          <input type="radio" value="free_shipping" v-model="form.product_page_display_mode">
          ارسال رایگان بدون محدودیت خرید
        </label>
      </div>

      <div class="flex justify-end mt-2">
        <div class="flex gap-2">
          <button
              v-if="editingId"
              @click="resetForm"
              class="px-3 py-1.5 bg-gray-200 text-gray-700 text-xs rounded-lg"
          >انصراف</button>
          <button
              @click="save"
              :disabled="saving"
              class="px-3 py-1.5 bg-emerald-600 text-white text-xs rounded-lg"
          >{{ editingId ? "ذخیره تغییرات" : "ساخت کد تخفیف" }}</button>
        </div>
      </div>
    </div>

    <!-- لیست -->
    <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <table class="w-full text-right">
        <thead class="bg-gray-50">
        <tr>
          <th class="p-3 text-xs font-medium text-gray-500 uppercase">کد</th>
          <th class="p-3 text-xs font-medium text-gray-500 uppercase">تخفیف</th>
          <th class="p-3 text-xs font-medium text-gray-500 uppercase">حداقل سفارش</th>
          <th class="p-3 text-xs font-medium text-gray-500 uppercase">استفاده شده</th>
          <th class="p-3 text-xs font-medium text-gray-500 uppercase">محدودیت‌ها</th>
          <th class="p-3 text-xs font-medium text-gray-500 uppercase">وضعیت</th>
          <th class="p-3 text-xs font-medium text-gray-500 uppercase"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="loading">
          <td colspan="7" class="p-6 text-center text-xs text-gray-400">در حال بارگذاری...</td>
        </tr>
        <tr v-else-if="!codes.length">
          <td colspan="7" class="p-6 text-center text-xs text-gray-400">هنوز کد تخفیفی ساخته نشده</td>
        </tr>
        <tr v-for="item in codes" :key="item.id" class="border-t hover:bg-gray-50">
          <td class="p-2 text-xs text-gray-700 font-mono">
            {{ item.code }}
            <span v-if="item.is_featured_on_product_page" class="mr-1 px-1.5 py-0.5 bg-amber-100 text-amber-700 rounded text-[10px]">صفحه محصول</span>
          </td>
          <td class="p-2 text-xs text-gray-500">
            {{ item.discount_type === 'f' ? formatNumber(item.fixed_amount) + ' تومان' : (item.discount_percentage || 0) + '٪' }}
          </td>
          <td class="p-2 text-xs text-gray-500">{{ Number(item.min_order_amount) > 0 ? formatNumber(item.min_order_amount) + ' تومان' : '—' }}</td>
          <td class="p-2 text-xs text-gray-500">{{ item.usage }} / {{ item.usage_limit || '∞' }}</td>
          <td class="p-2 text-xs text-gray-500 space-y-0.5">
            <div v-if="item.per_user_usage_limit">هر کاربر: {{ item.per_user_usage_limit }}</div>
            <div v-if="item.first_purchase_only" class="text-amber-600">فقط اولین خرید</div>
            <div v-if="!item.per_user_usage_limit && !item.first_purchase_only">—</div>
          </td>
          <td class="p-2 text-xs">
            <span :class="item.is_active ? 'text-emerald-600' : 'text-gray-400'">{{ item.is_active ? 'فعال' : 'غیرفعال' }}</span>
          </td>
          <td class="p-2 flex gap-1">
            <button
                @click="editCode(item)"
                class="px-2 py-1 bg-gray-200 text-gray-700 text-[11px] rounded-lg"
            >ویرایش</button>
            <button
                @click="deleteCode(item)"
                class="px-2 py-1 bg-red-500 text-white text-[11px] rounded-lg"
            >حذف</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiscountCodes",
  data() {
    return {
      codes: [],
      loading: false,
      saving: false,
      editingId: null,
      form: this.emptyForm(),
    };
  },
  created() {
    this.setDocumentTitle && this.setDocumentTitle("کدهای تخفیف");
    this.fetchCodes();
  },
  methods: {
    emptyForm() {
      return {
        code: "",
        discount_type: "p",
        discount_percentage: null,
        fixed_amount: null,
        max_discount_amount: null,
        min_order_amount: null,
        usage_limit: null,
        per_user_usage_limit: null,
        first_purchase_only: false,
        is_featured_on_product_page: false,
        product_page_display_mode: "amount",
        start_at: "",
        expire_at: "",
        is_active: true,
      };
    },
    formatNumber(val) {
      if (val === null || val === undefined) return "۰";
      return Number(val).toLocaleString("fa-IR");
    },
    generateCode() {
      const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
      let code = "";
      for (let i = 0; i < 8; i++) code += chars[Math.floor(Math.random() * chars.length)];
      this.form.code = code;
    },
    resetForm() {
      this.editingId = null;
      this.form = this.emptyForm();
    },
    editCode(item) {
      this.editingId = item.id;
      this.form = {
        code: item.code,
        discount_type: item.discount_type,
        discount_percentage: item.discount_percentage,
        fixed_amount: item.fixed_amount,
        max_discount_amount: item.max_discount_amount,
        min_order_amount: item.min_order_amount,
        usage_limit: item.usage_limit,
        per_user_usage_limit: item.per_user_usage_limit,
        first_purchase_only: item.first_purchase_only,
        is_featured_on_product_page: item.is_featured_on_product_page,
        product_page_display_mode: item.product_page_display_mode || "amount",
        start_at: item.start_at ? item.start_at.slice(0, 16) : "",
        expire_at: item.expire_at ? item.expire_at.slice(0, 16) : "",
        is_active: item.is_active,
      };
    },
    fetchCodes() {
      this.loading = true;
      this.request({
        url: this.endpoint("subscriptions/discountCodes"),
        method: "get",
        success: (data) => {
          this.codes = data || [];
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
    },
    save() {
      if (!this.form.code) {
        this.notify && this.notify("کد تخفیف الزامی است", "warning");
        return;
      }
      this.saving = true;
      const payload = {
        ...this.form,
        start_at: this.form.start_at || null,
        expire_at: this.form.expire_at || null,
      };
      const isEdit = !!this.editingId;
      this.request({
        url: this.endpoint(isEdit ? `subscriptions/discountCode/${this.editingId}` : "subscriptions/discountCodes"),
        method: isEdit ? "put" : "post",
        data: payload,
        success: () => {
          this.saving = false;
          this.notify && this.notify("ذخیره شد", "success");
          this.resetForm();
          this.fetchCodes();
        },
        error: () => {
          this.saving = false;
          this.notify && this.notify("خطا در ذخیره‌سازی", "danger");
        },
      });
    },
    deleteCode(item) {
      if (!window.confirm(`کد «${item.code}» حذف بشه؟`)) return;
      this.request({
        url: this.endpoint(`subscriptions/discountCode/${item.id}`),
        method: "delete",
        success: () => {
          this.notify && this.notify("حذف شد", "success");
          if (this.editingId === item.id) this.resetForm();
          this.fetchCodes();
        },
        error: () => {
          this.notify && this.notify("خطا در حذف", "danger");
        },
      });
    },
  },
};
</script>
